(() => {
  const init = (root) => {
    if (!root || root.dataset.sliderReady === 'true' || typeof window.Swiper !== 'function') return;
    const slider = root.querySelector('.ingredient-breakdown__slider');
    if (!slider) return;
    root.dataset.sliderReady = 'true';
    new window.Swiper(slider, {
      slidesPerView: 1.08,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        nextEl: root.querySelector('.ingredient-breakdown__arrow--next'),
        prevEl: root.querySelector('.ingredient-breakdown__arrow--prev'),
      },
      breakpoints: {
        750: { slidesPerView: 2.15 },
        990: { slidesPerView: 3, spaceBetween: 16 },
      },
    });
  };

  const initAll = () => document.querySelectorAll('[data-ingredient-breakdown]').forEach(init);
  const initWhenReady = (attempt = 0) => {
    if (typeof window.Swiper === 'function') {
      initAll();
      return;
    }
    if (attempt < 50) window.setTimeout(() => initWhenReady(attempt + 1), 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWhenReady());
  } else {
    initWhenReady();
  }

  window.addEventListener('load', () => initWhenReady());
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ingredient-breakdown]')));
})();
